import { ChangeDetectionStrategy, Component, ElementRef } from '@angular/core';
import { IonContent } from '@ionic/angular/standalone';

@Component({
  selector: 'lh-shared-ui-page-content',
  standalone: true,
  imports: [IonContent],
  templateUrl: './shared-ui-page-content.component.html',
  styleUrl: './shared-ui-page-content.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SharedUiPageContentComponent {
  constructor(private elRef: ElementRef<HTMLElement>) {
    //
    // HACK: The ion-content will have 0 height if it's not a direct child of the ion-page
    // https://forum.ionicframework.com/t/ioncontent-size-incorrect-if-content-contains-ng-content/189653/2
    //
    this.elRef.nativeElement.classList.add('ion-page');
  }
}
